import _ from 'underscore';

/**
 * Define a projection grid plugin
 * @param {string} name - Name of the plugin
 * @param {string[]} dependencies - Names of the dependent plugins
 * @param {PluginCallback} callback - The callback to apply the plugin
 * @return {ProjectionGridPlugin} - The projection-grid plugin
 */
export function defineGridPlugin(name, dependencies, callback) {
  return (options) => {
    if (_.isFunction(options)) {
      const definePlugin = options;

      return definePlugin(name, [
        'config',
        ...dependencies,
      ], (config, ...outputs) => callback(
        ...outputs,
        _.chain(config).result('plugins').result(name).value()
      ));
    }

    return definePlugin => definePlugin(
      name,
      dependencies,
      /**
       * @callback PluginCallback
       * @param {...*} outputs - The outputs of dependent plugins
       * @param {Object} options - The options for this plugin
       * @return {*} - The output of this plugin
       */
      (...outputs) => callback(...outputs, options)
    );
  };
}
